import { defineComponent, PropType } from 'vue';
import { CommonLinkTextNodeConfig } from '@/business/chat/generate-common-link-node-config';

export default defineComponent({
  name: 'CommonLinkTextNode',
  inheritAttrs: false,
  props: {
    commonLinkTextNodeConfig: {
      type: Object as PropType<CommonLinkTextNodeConfig>,
      default: () => null,
    },
  },
});
